module.exports = __webpack_public_path__ + "img/horarioFuncionamento.1bca467f.svg";